<template>
   <div class="bg-light-grey flex min-h-screen flex-col items-center justify-center px-4 py-16">
      <div class="w-full max-w-xl">
         <!-- Header -->
         <div class="mb-10 text-center">
            <div class="mb-4 flex items-center justify-center gap-3">
               <img src="/assets/logo.png" alt="Domus Laetitiae" class="h-10 object-contain" />
               <span class="text-2xl font-normal tracking-widest">VILLA</span>
            </div>
            <h2 class="h-m mb-1">Seleziona profilo</h2>
            <p class="p-s text-grey">Scegli un profilo demo per esplorare la piattaforma</p>
         </div>

         <!-- Profile list -->
         <div class="space-y-2.5">
            <div
               v-for="profile in demoProfiles"
               :key="profile.id"
               class="rounded-base cursor-pointer border border-[var(--ui-border)] bg-white px-5 py-4 transition-all"
               :class="selectedId === profile.id ? 'ring-2 ring-primary' : ''"
               @click="selectedId = profile.id"
            >
               <div class="flex items-center gap-3">
                  <UAvatar
                     :src="profile.avatar || undefined"
                     :text="
                        profile.label
                           .split(' ')
                           .map((w: string) => w[0])
                           .join('')
                     "
                     size="md"
                  />
                  <div class="min-w-0 flex-1">
                     <p class="p-m font-semibold">{{ profile.label }}</p>
                     <p class="p-s text-grey">{{ profile.subtitle }}</p>
                  </div>
                  <UIcon
                     v-if="selectedId === profile.id"
                     name="i-heroicons-check-circle-solid"
                     class="text-primary size-5 shrink-0"
                  />
               </div>
            </div>
         </div>

         <!-- Description -->
         <div
            v-if="selectedProfile?.description"
            :key="selectedId"
            v-motion
            :initial="{ opacity: 0, y: 8 }"
            :enter="{ opacity: 1, y: 0 }"
            class="rounded-base mt-5 border border-[var(--ui-border)] bg-white px-5 py-4"
         >
            <p class="p-s text-grey">{{ selectedProfile.description }}</p>
         </div>

         <!-- CTA -->
         <div class="mt-8">
            <UButton size="lg" block @click="enterDashboard">
               Entra nella piattaforma
            </UButton>
         </div>

         <div class="mt-4 text-center">
            <NuxtLink to="/" class="text-grey hover:text-primary p-s transition-colors">
               Torna alla home
            </NuxtLink>
         </div>
      </div>
   </div>
</template>

<script lang="ts" setup>
import { demoProfiles, guests } from '~/composables/useMockData'
import { useDemoStore } from '~/stores/demo-store'

definePageMeta({
   layout: false,
})

const router = useRouter()
const pinia = usePinia()
const store = useDemoStore(pinia)

const selectedId = ref(store.currentProfile.id)

const selectedProfile = computed(() => demoProfiles.find((p) => p.id === selectedId.value))

function enterDashboard() {
   const profile = selectedProfile.value
   if (!profile) return

   store.setProfile(profile.id)

   let targetFacility = profile.facility || 'fac_domus'
   if (profile.isFamily && profile.scopeId) {
      const guest = guests.find((g) => g.id === profile.scopeId)
      if (guest) targetFacility = guest.facility_id
   }

   router.push(`/dashboard/${targetFacility}`)
}
</script>
